import React, { forwardRef } from 'react'
import { Link, LinkProps, useResolvedPath } from 'react-router-dom'
import { localPageDestination } from './PageAnchor'
import { usePageDestinationAccess } from './usePageAccess'

// Associated data remains visible even when its destination page is denied.
// Keep row layout and child actions, but remove the anchor and its click action.
export const PageLink = forwardRef<HTMLAnchorElement, LinkProps>(
  (
    {
      to,
      children,
      onClick,
      target,
      rel,
      replace,
      state,
      reloadDocument,
      ...props
    },
    ref,
  ) => {
    const resolved = useResolvedPath(to)
    const canOpen = usePageDestinationAccess()
    const external =
      typeof to === 'string' && /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i.test(to)
    const destination = external
      ? localPageDestination(String(to))
      : resolved.pathname + resolved.search
    if (destination && !canOpen(destination)) {
      return (
        <span
          {...props}
          role={undefined}
          tabIndex={undefined}
          onKeyDown={undefined}
          onKeyUp={undefined}
          onMouseDown={undefined}
          style={{ ...props.style, cursor: 'default', textDecoration: 'none' }}
        >
          {children}
        </span>
      )
    }
    return (
      <Link
        {...props}
        ref={ref}
        to={to}
        onClick={onClick}
        target={target}
        rel={rel}
        replace={replace}
        state={state}
        reloadDocument={reloadDocument}
      >
        {children}
      </Link>
    )
  },
)
PageLink.displayName = 'PageLink'
